/* eslint-disable */
import { IntlShape } from "react-intl";
import { authService, isAuth, getToken } from "../auth";
import { httpInterceptors, NO_AUTH_STATUS, MIN_CODE_ERROR, CONFLICT_ERROR } from "./shared";
import { notistackService } from "../notistack/shared";
import messages from "./messages";

export * from "./shared";

/**
 * This is legacy, awaiting refactoring
 */
export function registerInterceptors(intl: IntlShape) {
  const cahngePassUrl = location.origin + "/api/UserProfile/changepassword";

  httpInterceptors.requestRegister(async (options = {}) => {
    if (isAuth()) {
      if (!options.headers) {
        options.headers = {};
      }
      const token = getToken();

      options.headers["Authorization"] = `Bearer ${token}`;
    }
    return options;
  });

  httpInterceptors.responseRegister(async (response) => {
    if (response.status === NO_AUTH_STATUS) {
      authService.logout();
    }

    if (response.status !== 200) {
    }

    if (intl && response.status >= MIN_CODE_ERROR && response.url !== cahngePassUrl) {
      const isHaveErrorNotification = notistackService.notifications.some(
        (notific) => intl && notific.message === intl.formatMessage(messages.responseErrorCodeMsg)
      );

      if (response.status === CONFLICT_ERROR) {
        try {
          const objError = await response.json();
          switch (objError.code) {
            case "BULK_EXPORT_MAX_LIMIT":
              notistackService.createSnackbar({
                message: intl.formatMessage(messages.responseErrorBulkExportMaxLimitMsg),
                variant: "error",
              });
              throw objError;
          }
        } catch (err) {
          if (document.location.host.includes("localhost")) {
            let msg = `ERROR: GET SERVER EXCEPTION`;
            console.log(msg);
          }
        }
      } else if (!isHaveErrorNotification) {
        notistackService.createSnackbar({
          message: intl.formatMessage(messages.responseErrorCodeMsg),
          variant: "error",
        });

        if (document.location.host.includes("localhost")) {
          let msg = `HTTP ERROR (${response.status}): ` + "\r\n";
          msg += (await response.text()) || "No message";
          throw new Error(msg);
        }
      }
    }

    return response;
  });
}
